import { doc, setDoc, updateDoc } from 'firebase/firestore';
import React, { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import { v4 } from 'uuid';
import * as Yup from 'yup';

import { useAuth } from '~/hooks/auth';
import { useToast } from '~/hooks/toast';
import ICompany from '~/interfaces/ICompany';
import { bff } from '~/services/bff';
import { DB } from '~/services/firebase';
import getValidationErrors from '~/utils/getValidationErrors';

interface SettingsCompanyProps {
  openMenu(): void;
}

const { REACT_APP_FIREBASE_PROJECT } = process.env;

const SettingsPayment: React.FC<SettingsCompanyProps> = ({ openMenu }) => {
  const { user, company, updateCompany } = useAuth();
  const { addToast } = useToast();
  const [data, setData] = useState<ICompany>(company);
  const [errors, setErrors] = useState({} as any);
  const [loading, setLoading] = useState(false);

  // useEffect(() => {
  //   if (company && company.uid) setData(company);
  // }, [company]);

  const handleSubmit = useCallback(
    async event => {
      event.preventDefault();

      try {
        setErrors({});

        const schema = Yup.object().shape({
          // pix_type: Yup.string().required('O tipo de chave é obrigatório'),
          // social_reason: Yup.string().required(
          //   'O campo razão social é obrigatório',
          // ),
          // pix: Yup.string().required('A chave pix é obrigatória'),
          // email: Yup.string()
          //   .required('O campo e-mail é obrigatório')
          //   .email('Informe um e-mail válido'),
          // address: Yup.string().required('O campo endereço é obrigatório'),
          // waiting_time: Yup.string().required(
          //   'O campo tempo de espera é obrigatório',
          // ),
          // pix_recipient: Yup.string().required('O beneficiário é obrigatório'),
          // service_hours: Yup.string().required(
          //   'O campo horário de atendimento é obrigatório',
          // ),
          // minimum_order: Yup.string().required(
          //   'O campo pedido mínimo é obrigatório',
          // ),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        setLoading(true);

        const parseData = {
          ...data,
          user_id: user.uid,
        };

        const uid = data.uid || v4();

        if (data.uid) {
          await updateDoc(doc(DB, 'companies', uid), parseData);
        } else {
          await setDoc(doc(DB, 'companies', uid), parseData);
        }

        await bff.delete(`/companies/${REACT_APP_FIREBASE_PROJECT}`);

        updateCompany(parseData);

        addToast({
          type: 'success',
          description:
            'As configurações de pagamentos foram salvas com sucesso!',
        });

        setLoading(false);
      } catch (err: any) {
        setLoading(false);
        if (err instanceof Yup.ValidationError) {
          const parseErrors = getValidationErrors(err);
          setErrors(parseErrors);
          return;
        }

        addToast({
          type: 'danger',
          description:
            'Infelizmente não foi possível completar a operação. Por favor, Tente novamente.',
        });
      }
    },
    [data, user, addToast, updateCompany],
  );

  return (
    <div className="nk-block">
      <div className="nk-block-head nk-block-between">
        <div className="nk-block-head-content">
          <h5 className="nk-block-title">Pagamentos</h5>
          <div className="nk-block-des">
            <p>Configurar opções de pagamentos.</p>
          </div>
        </div>
        <div className="nk-block-head-content align-self-start d-lg-none">
          <Link
            to="#menu"
            className="toggle btn btn-icon btn-trigger mt-n1"
            data-target="userAside"
            onClick={openMenu}
          >
            <em className="icon ni ni-menu-alt-r" />
          </Link>
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group mb-3">
              <label className="form-label" htmlFor="default-06">
                Ativar PIX
              </label>
              <div className="form-control-wrap ">
                <div className="form-control-select">
                  <select
                    className="form-control form-control-lg"
                    id="default-06"
                    defaultValue={data.pix_active}
                    onChange={event => {
                      setData({
                        ...data,
                        pix_active: event.target.value,
                      });
                    }}
                  >
                    <option value="0">Não</option>
                    <option value="1">Sim</option>
                  </select>
                  {errors.pix_active && (
                    <span className="invalid">{errors.pix_active}</span>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="col-sm-6">
            <div className="form-group mb-3">
              <label className="form-label">Tipo de Chave</label>
              <div className="form-control-wrap">
                <input
                  type="text"
                  className="form-control form-control-lg"
                  placeholder="CELULAR"
                  defaultValue={data.pix_type}
                  onChange={event => {
                    setData({
                      ...data,
                      pix_type: event.target.value,
                    });
                  }}
                />
                {errors.pix_type && (
                  <span className="invalid">{errors.pix_type}</span>
                )}
              </div>
            </div>
          </div>

          <div className="col-sm-6">
            <div className="form-group mb-3">
              <label className="form-label">Beneficiário</label>
              <div className="form-control-wrap">
                <input
                  type="text"
                  className="form-control form-control-lg"
                  placeholder="Nome do beneficiário"
                  defaultValue={data.pix_recipient}
                  onChange={event => {
                    setData({
                      ...data,
                      pix_recipient: event.target.value,
                    });
                  }}
                />
                {errors.pix_recipient && (
                  <span className="invalid">{errors.pix_recipient}</span>
                )}
              </div>
            </div>
          </div>

          <div className="col-sm-6">
            <div className="form-group mb-3">
              <label className="form-label">Chave PIX</label>
              <div className="form-control-wrap">
                <input
                  type="text"
                  className="form-control form-control-lg"
                  placeholder="Chave PIX"
                  defaultValue={data.pix}
                  onChange={event => {
                    setData({
                      ...data,
                      pix: event.target.value,
                    });
                  }}
                />
                {errors.pix && <span className="invalid">{errors.pix}</span>}
              </div>
            </div>
          </div>

          <div className="col-12">
            <hr />
          </div>

          <div className="col-sm-6">
            <div className="form-group mb-3">
              <label className="form-label" htmlFor="sell_on_credit">
                Habilitar Fiado?
              </label>
              <div className="form-control-wrap ">
                <div className="form-control-select">
                  <select
                    className="form-control form-control-lg"
                    id="sell_on_credit"
                    value={data.sell_on_credit}
                    onChange={event => {
                      setData({
                        ...data,
                        sell_on_credit: event.target.value,
                      });
                    }}
                  >
                    <option value="0">Não</option>
                    <option value="1">Sim</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12">
            <hr />
          </div>

          <div className="col-sm-4">
            <div className="form-group mb-3">
              <label className="form-label">Acréscimo Cartão de Crédito</label>
              <div className="form-control-wrap">
                <input
                  type="number"
                  className="form-control form-control-lg"
                  placeholder={`${
                    data.add_card_type === '1' ? '1%' : 'R$ 1,00'
                  }`}
                  defaultValue={data.add_card}
                  onChange={event => {
                    setData({
                      ...data,
                      add_card: parseFloat(event.target.value),
                    });
                  }}
                />
                {errors.pix && <span className="invalid">{errors.pix}</span>}
              </div>
            </div>
          </div>

          <div className="col-sm-2">
            <div className="form-group mb-3">
              <label className="form-label" htmlFor="default-06">
                <br />
              </label>
              <div className="form-control-wrap ">
                <div className="form-control-select">
                  <select
                    className="form-control form-control-lg"
                    id="default-06"
                    defaultValue={data.add_card_type}
                    onChange={event => {
                      setData({
                        ...data,
                        add_card_type: event.target.value,
                      });
                    }}
                  >
                    <option value="0">R$</option>
                    <option value="1">%</option>
                  </select>
                  {errors.add_card_type && (
                    <span className="invalid">{errors.add_card_type}</span>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="col-sm-4">
            <div className="form-group mb-3">
              <label className="form-label">Acréscimo Cartão de débito</label>
              <div className="form-control-wrap">
                <input
                  type="number"
                  className="form-control form-control-lg"
                  placeholder={`${
                    data.add_card2_type === '1' ? '1%' : 'R$ 1,00'
                  }`}
                  defaultValue={data.add_card2}
                  onChange={event => {
                    setData({
                      ...data,
                      add_card2: parseFloat(event.target.value),
                    });
                  }}
                />
                {errors.add_card2 && (
                  <span className="invalid">{errors.add_card2}</span>
                )}
              </div>
            </div>
          </div>

          <div className="col-sm-2">
            <div className="form-group mb-3">
              <label className="form-label" htmlFor="default-06">
                <br />
              </label>
              <div className="form-control-wrap ">
                <div className="form-control-select">
                  <select
                    className="form-control form-control-lg"
                    id="default-06"
                    defaultValue={data.add_card2_type}
                    onChange={event => {
                      setData({
                        ...data,
                        add_card2_type: event.target.value,
                      });
                    }}
                  >
                    <option value="0">R$</option>
                    <option value="1">%</option>
                  </select>
                  {errors.add_card2_type && (
                    <span className="invalid">{errors.add_card2_type}</span>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="col-sm-6">
            <div className="form-group mb-3">
              <label className="form-label">
                Link de pagamento Cartão de Crédito/Débito
              </label>
              <div className="form-control-wrap">
                <input
                  type="text"
                  className="form-control form-control-lg"
                  placeholder="Link de pagamento Cartão de Crédito/Débito"
                  defaultValue={data.payment_url || ''}
                  onChange={event => {
                    setData({
                      ...data,
                      payment_url: event.target.value,
                    });
                  }}
                />
              </div>
            </div>
          </div>

          <div className="form-group col-sm-12">
            <button
              type="submit"
              className="btn btn-primary btn-lg"
              disabled={loading}
            >
              {loading && (
                <div
                  className="spinner-border spinner-border-sm"
                  role="status"
                />
              )}
              {!loading && 'Salvar'}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default SettingsPayment;
